import React from 'react';

export const PogDrabinaText = () => {
  return (
    <p>
      Використовують лише за призначенням. Використовувати для господарських або інших потреб, не пов’язаних із
      пожежогасінням, заборонено.
    </p>
  );
};
